const getLoadBalancedUrl = (url: string, s3Path: string) => {
  // create a semi random token to should be the same each time it is generated for
  // a given path.
  const token = url.charCodeAt(url.length - 6) % 5;

  // PROD CDN
  if (url.startsWith('http://pp-ben-app-prod-public')) {
    return `https://${token}.cdn.ben.app.productplacement.com${s3Path}`;
  }

  // DEV CDN
  if (url.startsWith('http://pp-ben-app-dev-public')) {
    return `https://${token}.cdn.benapp.dev.pp.muyben.tech${s3Path}`;
  }

  // everything else, use what is in DB
  return url;
};

export default getLoadBalancedUrl;
